<template>
	<div class="p-4 md:p-6 flex-1 overflow-y-auto font-sans">
		<!-- ── Section Header ── -->
		<div class="flex items-center justify-between mb-6 pb-5 border-b border-primary-100 dark:border-dark-600">
			<div class="flex items-center gap-3">
				<div
					class="w-10 h-10 rounded-xl bg-primary-50 dark:bg-primary-400/15 flex items-center justify-center flex-shrink-0">
					<svg class="w-5 h-5 text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
							d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
					</svg>
				</div>
				<div>
					<h1
						class="font-display text-xl md:text-2xl font-extrabold tracking-tight text-dark-700 dark:text-white">
						Event Management
					</h1>
					<p class="text-[13px] text-muted dark:text-muted-light mt-0.5">
						All your events in one place
					</p>
				</div>
			</div>
		</div>

		<Breadcrumbs />

		<!-- ── Content ── -->
		<div
			class="bg-surface dark:bg-dark-700 rounded-card shadow-card border border-primary-100 dark:border-dark-600 p-6 transition-colors duration-300">

			<!-- Loading -->
			<div v-if="isLoading" class="flex flex-col items-center justify-center py-16 gap-3">
				<svg class="w-6 h-6 animate-spin text-primary-400" fill="none" viewBox="0 0 24 24">
					<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
					<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
				</svg>
				<p class="text-[13px] text-muted dark:text-muted-light">Loading events…</p>
			</div>

			<!-- Error -->
			<div v-else-if="error" class="flex flex-col items-center justify-center py-16 gap-3">
				<p class="text-[13px] text-red-500">{{ error }}</p>
				<button @click="fetchEvents" class="text-[13px] font-bold text-primary-600 hover:underline">
					Try again
				</button>
			</div>

			<!-- Data -->
			<EventList v-else :events="events || []" />
		</div>
	</div>
</template>

<script>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import EventList from "@/components/EventList.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
	components: { EventList, Breadcrumbs },
	setup() {
		const store = useStore();
		const events = computed(() => store.state.event.events);
		const isLoading = computed(() => store.state.event.loading);
		const error = computed(() => store.state.event.error);
		const fetchEvents = () => store.dispatch("event/fetchAllEvents");

		onMounted(() => {
			if (!events.value || events.value.length === 0) fetchEvents();
		});

		return { events, isLoading, error, fetchEvents };
	},
};
</script>
